// @flow
import styled from '@emotion/styled';
import { colors } from '@atlaskit/theme';
import { grid } from '../constants';

// $ExpectError - not sure why
export default styled.h2`
  padding: 15px;
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  transition: background-color ease 0.2s;
  flex-grow: 1;
  user-select: none;
  position: relative;

  &:focus {
    outline: 2px solid ${colors.P100};
    outline-offset: 2px;
  }
`;
